import React from 'react';
import "./Projects.css";
import { FiExternalLink, FiGithub, } from "react-icons/fi";
import congomart from "../../assets/images/congomart.png";
import parousia2 from "../../assets/images/parousia2.png";
import fue from "../../assets/images/fue.png";
import cmart from "../../assets/images/cmart.png";

const Projects = () => {
    const projects = [
        {
            title: "Congo Mart",
            category: "E-Commerce Marketplace",
            img: congomart,
            link: "https://congomart.com",
            tech: ["React", "Node.js", "PostgreSQL"],
            id: "01"
        },
        {
            title: "Parousia Group",
            category: "Digital Infrastructure & Technology",
            img: parousia2,
            link: "https://www.parousiagroup.com/fr",
            tech: ["Node.js", "Express.js", "DDD", "React", "Docker"],
            id: "02"
        },
        {
            title: "Fondation Ultime Espoir",
            category: "Humanitarian & Social Impact Platform",
            img: fue,
            link: "https://fondationultimeespoir.org/",
            tech: ["Node.js", "Socket.IO", "Redis"],
            id: "03"
        },
        {
            title: "Afrika Plaza",
            category: "Cross-Border Commerce Marketplace",
            img: cmart,
            link: "https://play.google.com/store/apps/details?id=com.congo_mart&pcampaignid=web_share",
            tech: ["React", "Node.js", "AWS", "Hexagonal Architecture"],
            id: "04"
        }
    ];

    return (
        <section className='projects-cyber' id="projects">
            <div className='container'>
                <div className='projects-heading'>
                    <div className='heading-left'>
                        <span className='line-decorator'></span>
                        <h2 className='glitch-text'>PROJETS_SÉLECTIONNÉS</h2>
                    </div>
                    <p className='heading-desc'>
                        Déploiement de solutions robustes alliant esthétique et performance industrielle.
                    </p>
                </div>

                <div className='projects-display'>
                    {projects.map((p) => (
                        <div className='cyber-card' key={p.id}>
                            <div className='card-header'>
                                <span className='project-id'>{p.id}</span>
                                <span className='project-category'>{p.category}</span>
                            </div>

                            <div className='image-container'>
                                <img src={p.img} alt={p.title} />
                                <div className='image-overlay'>
                                    <button onClick={() => window.open(p.link, '_blank')} className='action-btn'>
                                        <FiExternalLink /> Lancer
                                    </button>
                                </div>
                            </div>

                            <div className='card-footer'>
                                <h3>{p.title}</h3>
                                <div className='tech-stack-mini'>
                                    {p.tech.map(t => <span key={t}>{t}</span>)}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className='github-footer'>
                    <a href="https://github.com/StephaneCash" target="_blank" rel="noreferrer" className='github-link'>
                        <FiGithub /> <span>VOIR LE CODE SOURCE COMPLET</span>
                    </a>
                </div>
            </div>
        </section>
    );
}

export default Projects;